import React from 'react';
import { Tooltip } from '@fluentui/react-components';
import { Tag16Regular, Tag20Regular } from '@fluentui/react-icons';
import { hierarchicalKeywordsTooltipContent, hasHierarchicalKeywords } from '../../utils/dataroomKeywords';
import styles from './css/index.module.css';

/**
 * Tag icon + tooltip when rollup keywords exist (workstream / folder / file).
 */
export default function HierarchicalKeywordsHint({ keywords, compact = false }) {
    if (!hasHierarchicalKeywords(keywords)) return null;

    const body = hierarchicalKeywordsTooltipContent(keywords);
    const Icon = compact ? Tag16Regular : Tag20Regular;

    return (
        <Tooltip
            content={<div className={styles.keywordTooltipInner}>{body}</div>}
            relationship="description"
            positioning="above"
            withArrow>
            <span className={styles.keywordHintWrap} tabIndex={0} role="img" aria-label={`Keywords: ${body.replace(/\n/g, ', ')}`}>
                <Icon className={styles.keywordHintIcon} />
            </span>
        </Tooltip>
    );
}
